import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {CloBadge} from './badge';
export {CloBadge} from './badge';
@NgModule(
  {
    declarations: [CloBadge],
    exports: [CloBadge],
    imports: [CommonModule],
    entryComponents: [CloBadge]
  })

export class CloBadgeModule {
}
